import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './LandingLegalPage.css';
import messages from '../../locale/messages';
import { legalRichTextValues } from './legalMessageValues';
import LandingLegalPage from './LandingLegalPage';

const RichText = ({ message }) => (
  <FormattedMessage {...message} values={legalRichTextValues} />
);

class LandingTerms extends React.Component {
  static propTypes = {
    pageTitleMessage: PropTypes.object,
  };

  static defaultProps = {
    pageTitleMessage: messages.newLandingLegalTermsPageTitle,
  };

  render() {
    const { pageTitleMessage } = this.props;
    return (
      <LandingLegalPage
        activePage="terms"
        pageTitleMessage={pageTitleMessage}
      >
        <section className={s.legalSection}>
          <h2><FormattedMessage {...messages.newLandingLegalTermsServiceHeading} /></h2>
          <p><RichText message={messages.newLandingLegalTermsLastUpdated} /></p>
          <p><RichText message={messages.newLandingLegalTermsPleaseRead} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS1Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS1P1} /></p>
          <p><RichText message={messages.newLandingLegalTermsS1P2} /></p>
          <p><RichText message={messages.newLandingLegalTermsS1Definitions} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalTermsS1Def1} /></li>
            <li><RichText message={messages.newLandingLegalTermsS1Def2} /></li>
            <li><RichText message={messages.newLandingLegalTermsS1Def3} /></li>
            <li><RichText message={messages.newLandingLegalTermsS1Def4} /></li>
            <li><RichText message={messages.newLandingLegalTermsS1Def5} /></li>
          </ul>
          <p><RichText message={messages.newLandingLegalTermsS1P3} /></p>
          <p><RichText message={messages.newLandingLegalTermsS1P4} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS2Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS2P1} /></p>
          <p><RichText message={messages.newLandingLegalTermsS2P2} /></p>
          <p><RichText message={messages.newLandingLegalTermsS2P3} /></p>
          <p><RichText message={messages.newLandingLegalTermsS2P4} /></p>
          <p><RichText message={messages.newLandingLegalTermsS2Licence} /></p>
          <p><RichText message={messages.newLandingLegalTermsS2Ownership} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS3Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS3P1} /></p>
          <p><RichText message={messages.newLandingLegalTermsS3P2} /></p>
          <p><RichText message={messages.newLandingLegalTermsS3P3} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS4Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS4Intro} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalTermsS4Item1} /></li>
            <li><RichText message={messages.newLandingLegalTermsS4Item2} /></li>
            <li><RichText message={messages.newLandingLegalTermsS4Item3} /></li>
            <li><RichText message={messages.newLandingLegalTermsS4Item4} /></li>
            <li><RichText message={messages.newLandingLegalTermsS4Item5} /></li>
            <li><RichText message={messages.newLandingLegalTermsS4Item6} /></li>
            <li><RichText message={messages.newLandingLegalTermsS4Item7} /></li>
            <li><RichText message={messages.newLandingLegalTermsS4Item8} /></li>
          </ul>
          <p><RichText message={messages.newLandingLegalTermsS4Outro} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS5Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS5Intro} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalTermsS5Item1} /></li>
            <li><RichText message={messages.newLandingLegalTermsS5Item2} /></li>
            <li><RichText message={messages.newLandingLegalTermsS5Item3} /></li>
            <li><RichText message={messages.newLandingLegalTermsS5Item4} /></li>
            <li><RichText message={messages.newLandingLegalTermsS5Item5} /></li>
            <li><RichText message={messages.newLandingLegalTermsS5Item6} /></li>
          </ul>
          <p><RichText message={messages.newLandingLegalTermsS5Outro} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS6Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS6P1} /></p>
          <p><RichText message={messages.newLandingLegalTermsS6P2} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS7Heading} /></h3>
          <ul>
            <li><RichText message={messages.newLandingLegalTermsS7Charges} /></li>
            <li><RichText message={messages.newLandingLegalTermsS7Payment} /></li>
            <li><RichText message={messages.newLandingLegalTermsS7ServiceFee} /></li>
            <li><RichText message={messages.newLandingLegalTermsS7PreAuth} /></li>
            <li><RichText message={messages.newLandingLegalTermsS7Insurance} /></li>
            <li><RichText message={messages.newLandingLegalTermsS7Damage} /></li>
            <li><RichText message={messages.newLandingLegalTermsS7Refunds} /></li>
          </ul>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS8Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS8Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS9Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS9Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS10Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS10Intro} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalTermsS10Item1} /></li>
            <li><RichText message={messages.newLandingLegalTermsS10Item2} /></li>
            <li><RichText message={messages.newLandingLegalTermsS10Item3} /></li>
            <li><RichText message={messages.newLandingLegalTermsS10Item4} /></li>
            <li><RichText message={messages.newLandingLegalTermsS10Item5} /></li>
            <li><RichText message={messages.newLandingLegalTermsS10Item6} /></li>
          </ul>
          <p><RichText message={messages.newLandingLegalTermsS10Outro} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS11Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS11Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS12Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS12Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS13Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS13Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS14Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS14Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS15Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS15Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS16Heading} /></h3>
          <p><RichText message={messages.newLandingLegalTermsS16Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsS17Heading} /></h3>
          <ul>
            <li><RichText message={messages.newLandingLegalTermsS17Item1} /></li>
            <li><RichText message={messages.newLandingLegalTermsS17Item2} /></li>
            <li><RichText message={messages.newLandingLegalTermsS17Item3} /></li>
            <li><RichText message={messages.newLandingLegalTermsS17Item4} /></li>
            <li><RichText message={messages.newLandingLegalTermsS17Item5} /></li>
            <li><RichText message={messages.newLandingLegalTermsS17Item6} /></li>
          </ul>

          <hr className={s.sectionDivider} />
          <h2><FormattedMessage {...messages.newLandingLegalPrivacyHeading} /></h2>
          <p><RichText message={messages.newLandingLegalPrivacyLastUpdated} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS1Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS1P1} /></p>
          <p><RichText message={messages.newLandingLegalPrivacyS1P2} /></p>
          <p><RichText message={messages.newLandingLegalPrivacyS1Role} /></p>
          <p><RichText message={messages.newLandingLegalPrivacyS1P3} /></p>
          <p><RichText message={messages.newLandingLegalPrivacyS1Controller} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS1Controller1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS1Controller2} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS1Controller3} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS1Controller4} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS1Controller5} /></li>
          </ul>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS2Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS2P1} /></p>
          <p><RichText message={messages.newLandingLegalPrivacyS2Definitions} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS2Def1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS2Def2} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS2Def3} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS2Def4} /></li>
          </ul>
          <p><RichText message={messages.newLandingLegalPrivacyS2P2} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS3Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS3P1} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS3Law1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS3Law2} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS3Law3} /></li>
          </ul>
          <p><RichText message={messages.newLandingLegalPrivacyS3P2} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS3Basis1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS3Basis2} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS3Basis3} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS3Basis4} /></li>
          </ul>
          <p><RichText message={messages.newLandingLegalPrivacyS3P3} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS4Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS4Intro} /></p>
          <p className={s.legalSubheading}><RichText message={messages.newLandingLegalPrivacyS4IdentityHeading} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS4Identity1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS4Identity2} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS4Identity3} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS4Identity4} /></li>
          </ul>
          <p className={s.legalSubheading}><RichText message={messages.newLandingLegalPrivacyS4ContactHeading} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS4Contact1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS4Contact2} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS4Contact3} /></li>
          </ul>
          <p className={s.legalSubheading}><RichText message={messages.newLandingLegalPrivacyS4VehicleHeading} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS4Vehicle1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS4Vehicle2} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS4Vehicle3} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS4Vehicle4} /></li>
          </ul>
          <p className={s.legalSubheading}><RichText message={messages.newLandingLegalPrivacyS4TransactionHeading} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS4Transaction1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS4Transaction2} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS4Transaction3} /></li>
          </ul>
          <p className={s.legalSubheading}><RichText message={messages.newLandingLegalPrivacyS4LocationHeading} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS4Location1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS4Location2} /></li>
          </ul>
          <p className={s.legalSubheading}><RichText message={messages.newLandingLegalPrivacyS4CarScanHeading} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS4CarScan1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS4CarScan2} /></li>
          </ul>
          <p className={s.legalSubheading}><RichText message={messages.newLandingLegalPrivacyS4UsageHeading} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS4Usage1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS4Usage2} /></li>
          </ul>
          <p className={s.legalSubheading}><RichText message={messages.newLandingLegalPrivacyS4CommsHeading} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS4Comms1} /></li>
          </ul>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS5Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS5Intro} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS5Item1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS5Item2} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS5Item3} /></li>
          </ul>
          <p><RichText message={messages.newLandingLegalPrivacyS5Outro} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS6Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS6Intro} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS6Item1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS6Item2} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS6Item3} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS6Item4} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS6Item5} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS6Item6} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS6Item7} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS6Item8} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS6Item9} /></li>
          </ul>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS7Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS7P1} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS7Item1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS7Item2} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS7Item3} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS7Item4} /></li>
          </ul>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS8Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS8Intro} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS8Item1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS8Item2} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS8Item3} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS8Item4} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS8Item5} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS8Item6} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS8Item7} /></li>
          </ul>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS9Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS9Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS10Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS10Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS11Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS11Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS12Heading} /></h3>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS12Device} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS12Marketing} /></li>
          </ul>
          <p><RichText message={messages.newLandingLegalPrivacyS12RightsIntro} /></p>
          <ul>
            <li><RichText message={messages.newLandingLegalPrivacyS12Rights1} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS12Rights2} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS12Rights3} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS12Rights4} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS12Rights5} /></li>
            <li><RichText message={messages.newLandingLegalPrivacyS12Rights6} /></li>
          </ul>
          <p><RichText message={messages.newLandingLegalPrivacyS12RightsOutro} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS13Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS13Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS14Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS14Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS15Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS15Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS16Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS16Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyS17Heading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyS17Text} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyContactHeading} /></h3>
          <p><RichText message={messages.newLandingLegalPrivacyContactText1} /></p>
        </section>
      </LandingLegalPage>
    );
  }
}

export default withStyles(s)(LandingTerms);
